import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonialsData } from '../data/mockData';

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="bg-[#141414] p-8 border border-[#2a2a2a] h-full flex flex-col">
      {/* Quote Icon */}
      <Quote size={32} className="text-[#c9a962] mb-6" strokeWidth={1} />
      
      {/* Quote Text */}
      <p className="body-large text-[#b3b3b3] mb-8 flex-grow italic">
        "{testimonial.quote}"
      </p>
      
      {/* Rating */}
      <div className="flex gap-1 mb-6">
        {[...Array(testimonial.rating)].map((_, i) => (
          <Star key={i} size={16} className="text-[#c9a962] fill-[#c9a962]" />
        ))}
      </div>
      
      {/* Author */}
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 overflow-hidden border border-[#c9a962]/30">
          <img 
            src={testimonial.image}
            alt={testimonial.name}
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <h4 className="heading-3 text-white">{testimonial.name}</h4>
          <p className="body-small text-[#808080]">
            {testimonial.role}, {testimonial.business}
          </p>
        </div>
      </div>
    </div>
  );
};

const Testimonials = () => {
  return (
    <section id="testimonials" className="section-padding bg-[#0a0a0a]">
      <div className="container">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-sm font-medium text-[#c9a962] tracking-wider uppercase mb-4">
            Testimonials
          </span>
          
          <h2 className="heading-1 text-white mb-6">
            What Clients Say
          </h2>
          
          <p className="body-large text-[#b3b3b3]">
            Don't just take my word for it — here's what brands I've worked with have to say.
          </p>
        </div>
        
        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonialsData.map((testimonial) => (
            <TestimonialCard key={testimonial.id} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
